
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/questions/[questionId]/[username]",
      function () {
        return require("private-next-pages/questions/[questionId]/[username].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/questions/[questionId]/[username]"])
      });
    }
  